import { render, staticRenderFns } from "./MediaPlanTable.vue?vue&type=template&id=183f1133&"
import script from "./MediaPlanTable.vue?vue&type=script&lang=ts&"
export * from "./MediaPlanTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports